import React from "react";
import { useLocation } from "react-router-dom";
import styled, { keyframes } from "styled-components";

const fadeIn = keyframes`
  from { opacity: 0; transform: scale(0.95); }
  to { opacity: 1; transform: scale(1); }
`;

const FullScreenIframeContainer = styled.div`
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background: white;
  animation: ${fadeIn} 0.5s ease-in-out;
`;

const FullScreenIframe = styled.iframe`
  width: 100%;
  height: 100%;
  border: none;
`;

const pathToUrlMap = {
  "/Portal/Instructor/Training&ComplianceMSSP": "https://training.studyak.ai/mssp/login",
  "/Portal/Instructor/Training&ComplianceAdmin": "https://training.studyak.ai/4jSmdmdDoLCQR/jx3azBhhpuRclGem",
  "/Portal/Instructor/Training&ComplianceCompany": "https://training.studyak.ai/company/login",
};

const TrainingCompliance = () => {
  const location = useLocation();
  const currentUrl = pathToUrlMap[location.pathname] || "https://training.studyak.ai/mssp/login";

  return (
    <FullScreenIframeContainer>
      <FullScreenIframe src={currentUrl} />
    </FullScreenIframeContainer>
  );
};

export default TrainingCompliance;
